/*
 * @Author: liuxw@codoon.com
 * @Date: 2020-07-02 16:57:31
 * @Last Modified by: liuxw@codoon.com
 * @Last Modified time: 2022-06-29 17:05:24
 * @Content:
 */

import React, { useEffect, useCallback } from "react";
import html2canvas from "html2canvas";
import Modal from "../../Common/Modal/Modal";
import { IPostCreateTempDetail, IUserinfo } from "../../../service/Index";
import "./index.less";
import { useShowToast } from "../../../hooks/utilHooks";
import { IActivityInfo } from "../../../service/activity/interface";
import { Toast } from "codoon-come";
import iconShare from "../../../assets/imgs/challenge_icon_share@2x.png";
import { isInCodoon, customerShare } from "../../../utils/bridge";
import { openCodoon } from "open-codoon";
import { tempBtnColorSelecor } from "../../../store/common/selector";
import { connect } from "react-redux";
import indexService from "../../../service/Index";
import { DEFAULT_GIFT_URL } from "./const";

const { GlobalToast } = Toast;

const PREFIX = "ActivityNewUserRewardModal";

type IProps = {
  visible: boolean;
  onClose: () => void;
  activityDetail: IActivityInfo;
  tempDetail: IPostCreateTempDetail;
  user_info: IUserinfo;
} & ReturnType<typeof mapStateToProps>;

const RewardModalCore: React.FC<IProps> = React.memo(
  ({ visible, onClose, activityDetail, tempDetail, tempBtnColor, user_info }) => {
    const { toastVisible, toastTip, showToast } = useShowToast();
    const [countTime, setCountTime] = React.useState('');
    const [feedBgImg, setFeedBgImg] = React.useState('');
    const [portraitImg, setPortraitImg] = React.useState('');
    const [shareImg, setShareImg] = React.useState('');
    const couponTimerRef = React.useRef<number | null>(null);

    // 各个礼包跳转
    const jumpToOtherPage = useCallback((type: number, url: string, value: string) => {
      if (!isInCodoon()) {
        // 唤醒咕咚个并进入当前活动页
        openCodoon(window.location.origin + window.location.pathname, "h5");
      } else {
        if (url) {
          window.location.href = url;
        } else {
          if (type === 3) {
            window.location.href = `https://xmall.codoon.com/channel/html/goods-table.html?name=${value}&type=3`;
          } else if (DEFAULT_GIFT_URL[type as keyof typeof DEFAULT_GIFT_URL].url) {
            window.location.href = DEFAULT_GIFT_URL[type as keyof typeof DEFAULT_GIFT_URL].url;
          }
        }

      }
    }, []);

    // 新人礼包获取奖励
    const getNewUserReward = useCallback((cb?: () => void): void => {
      indexService
        .getNewUserGift({
          activity_id: Number(activityDetail.activity_id),
        })
        .then((response) => {
          if (response.status == "OK") {
            cb?.();
          } else {
            if (response.description.indexOf('已领取') === -1) {
              showToast(response.description);
            }
          }
        });
    }, [activityDetail, showToast]);

    // 获取优惠券倒计时
    const getVipCouponStatus = useCallback(() => {
      indexService
        .getNewUserGiftCoupon({
          activity_id: Number(activityDetail.activity_id),
        })
        .then((response) => {
          if (response.status == "OK") {
            if (response.data.state === 1 && response.data.items.length > 0 && response.data.items[0].count_down_end_time) {
              const endTime = new Date(response.data.items[0].count_down_end_time.replace(/-/g, '/')).getTime();

              // 清理旧定时器，避免重复
              if (couponTimerRef.current) {
                clearInterval(couponTimerRef.current);
                couponTimerRef.current = null;
              }

              const update = () => {
                const remainSeconds = Math.floor((endTime - Date.now()) / 1000);
                if (remainSeconds <= 0) {
                  setCountTime('已结束');
                  if (couponTimerRef.current) {
                    clearInterval(couponTimerRef.current);
                    couponTimerRef.current = null;
                  }
                  return;
                }
                const hours = Math.floor(remainSeconds / 3600);
                const minutes = Math.floor((remainSeconds % 3600) / 60);
                const seconds = remainSeconds % 60;
                const pad = (n: number) => n.toString().padStart(2, '0');
                setCountTime(`${pad(hours)}:${pad(minutes)}:${pad(seconds)}`);
              };

              // 立即执行一次，随后每秒更新
              update();
              couponTimerRef.current = window.setInterval(update, 1000);
            } else if (response.data.state === 0) {
              getNewUserReward(() => { getVipCouponStatus() });
            }
          } else {
            showToast(response.description);
          }
        });
    }, [setCountTime, getNewUserReward, activityDetail, showToast]);

    // 新人礼包去分享
    const getNewUserGoShare = useCallback(() => {
      indexService
        .getNewUserGoShare({
          activity_id: Number(activityDetail.activity_id),
        })
        .then((response) => {
          if (response.status !== "OK") {
            showToast(response.description);
          }
        });
    }, [activityDetail, showToast]);

    // 分享图片
    const goShareImg = useCallback(async () => {
      if (!shareImg) return;
      await getNewUserGoShare();
      customerShare({
        sCodoonShareShareContentForSportCircle: tempDetail.reword_list.new_comer_gift_pack_reward.share_feed_title,
        sCodoonShareShareImageUrlsForSportCircle: [shareImg],
        sCodoonShareShareLabelID: 142498, //正式：142498 测试：123
        sCodoonShareShareLabelContent: '#\u2005新人挑战成就达成\u2005',
        oCodoonShareDestination: {
          codoonTimeline: true,
          codoonGroup: false,
          weixinToFriend: false,
          weixinToTimeline: false,
          sinaWeibo: false,
          tencentQQ: false,
          tencentQzone: false,
        },
        sCodoonShareContentType: 1
      });
    }, [shareImg, tempDetail])

    const uploadFeedBgImg = useCallback(() => {
      if (!tempDetail.reword_list.new_comer_gift_pack_reward.share_feed_img) {
        return;
      }
      return indexService
        .getBase64PicUrl({
          url: tempDetail.reword_list.new_comer_gift_pack_reward.share_feed_img,
        })
        .then((response) => {
          if (response.status) {
            setFeedBgImg(response.data);
          }
        });
    }, [setFeedBgImg, tempDetail])

    const uploadPortraitImg = useCallback(() => {
      return indexService
        .getBase64PicUrl({
          url: user_info.portrait,
        })
        .then((response) => {
          if (response.status) {
            setPortraitImg(response.data);
          }
        });
    }, [setPortraitImg, user_info])

    // 上传base64图片到又拍云
    const uploadCanvasImg = useCallback((canvasImg: string) => {
      const param = { data: canvasImg, type: "image/png" };
      indexService.uploadBase64Img(param).then((response) => {
        if (!response.status) return;
        setShareImg(response.data);
      });
    }, [setShareImg])

    const uploadAllImg = useCallback(async () => {
      await uploadFeedBgImg();
      await uploadPortraitImg();
      const shareFeedImgEl = document.getElementById("share-feed-img");
      if (!shareFeedImgEl) return;
      html2canvas(shareFeedImgEl, {
        allowTaint: true, useCORS: true, width: 375, height: 478
      }).then((canvas) => {
        const base64 = canvas.toDataURL("image/png");
        uploadCanvasImg(base64);
      });
    }, [uploadFeedBgImg, uploadPortraitImg, uploadCanvasImg])

    useEffect(() => {
      // 只有pack_items里有type为1的才调用getVipCouponStatus
      if (
        visible && activityDetail.activity_id && tempDetail?.reword_list?.new_comer_gift_pack_reward?.pack_items?.some(
          (item: any) => item.type === 1
        )
      ) {
        setShareImg(tempDetail.reword_list.new_comer_gift_pack_reward.share_feed_img);
        getVipCouponStatus();
      }
      // 生成分享图
      if (visible && user_info?.portrait && tempDetail?.reword_list.new_comer_gift_pack_reward?.share_feed_img) {
        uploadAllImg();
      }
      return () => {
        if (couponTimerRef.current) {
          clearInterval(couponTimerRef.current);
          couponTimerRef.current = null;
        }
      }
    }, [getVipCouponStatus, uploadAllImg, user_info, tempDetail, visible, activityDetail]);

    // 页面从后台返回时刷新一次倒计时，避免跳变
    useEffect(() => {
      const handleVisibility = () => {
        if (document.visibilityState === 'visible' && visible) {
          getVipCouponStatus();
        }
      };
      document.addEventListener('visibilitychange', handleVisibility);
      return () => {
        document.removeEventListener('visibilitychange', handleVisibility);
      };
    }, [visible, getVipCouponStatus]);

    const renderShareImg = () => {
      if (!feedBgImg || !portraitImg) {
        return null;
      }
      return (<div className="share-feed-img" id="share-feed-img">
        <img className="share-bg" src={feedBgImg} alt="" />
        <div className="user-info-con">
          <img className="tx-img" src={portraitImg} alt="" />
          <p className="nick">{user_info.nick}<span> 🎉恭喜成功领取新人奖励！</span></p>
        </div>
      </div>)
    }

    return (
      <Modal
        visible={visible}
        animation="fade"
        onClose={onClose}
        className={PREFIX}
      >
        {toastVisible && <GlobalToast text={toastTip} />}
        <div className="close-btn" onClick={onClose} />
        {/* 礼包内容 */}
        <div className="gift-list">
          {tempDetail?.reword_list.new_comer_gift_pack_reward?.pack_items?.map((item, index) => {
            return (<div className={item.type === 1 ? "gift-li gift-li-vip" : "gift-li gift-li-normal"} key={index}>
              <p className="gift-num">{index + 1}</p>
              <img className="gift-img" src={item.image} />
              {item.type !== 1 && <p className="gift-name">{item.text}</p>}
              <div className="gift-btn" onClick={() => {
                jumpToOtherPage(item.type, item.jump_url, item.value)
              }}>{item.button_text}</div>
              {item.type === 1 && countTime && (
                <div className="cut-down-time">
                  {countTime}
                </div>
              )}
            </div>)
          })}
        </div>
        {/* 底部分享按钮 */}
        <div className="share-btn" onClick={goShareImg}>
          <p>{tempDetail.reword_list.new_comer_gift_pack_reward.share_title}</p>
          <img src={iconShare} alt="" />
        </div>
        {/* 隐藏的分享图 */}
        {renderShareImg()}
        {/* <img className="test-img" src={shareImg} alt="" /> */}
      </Modal>
    );
  }
);

const mapStateToProps = (state: any) => {
  return {
    tempBtnColor: tempBtnColorSelecor(state),
  };
};

export const NewUserRewardModal = connect(mapStateToProps)(RewardModalCore);
